import { PageHeader } from '@verantos-dev/shared-components';

import { useProjectsListPageHeader } from '../../hooks/useProjectsListPageHeader';
import { CreateProjectModal } from '../CreateProjectModal/CreateProjectModal';
import { DatasetDetailsModal } from '../DatasetDetailsModal/DatasetDetailsModal';
import { DeleteProjectModal } from '../DeleteProjectModal/DeleteProjectModal';

export const ProjectsListPageHeader = () => {
  const {
    actions,
    pageTitle,
    isCreateProjectModalOpen,
    isDeleteProjectModalOpen,
    isDatasetDetailsModalOpen,
    datasetInfo,
  } = useProjectsListPageHeader();
  return (
    <>
      <PageHeader id="projectsListPageHeader" pageTitle={pageTitle} actions={actions} />
      {isCreateProjectModalOpen && <CreateProjectModal />}
      {isDeleteProjectModalOpen && <DeleteProjectModal />}
      {isDatasetDetailsModalOpen && datasetInfo && (
        <DatasetDetailsModal
          releaseId={datasetInfo.datasetId}
          releaseName={datasetInfo.datasetName}
        />
      )}
    </>
  );
};
